// extracted by mini-css-extract-plugin
export default {"box":"HoverBox_box__Tjyng"};